import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { useTheme } from '@emotion/react';
import { tokens } from '../theme';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

/**
 * Reusable ColorSelector component for selecting colors in a circular grid
 * @param {object} props
 * @param {Array} props.colors - Array of color options with {name, value} structure
 * @param {string} props.selectedColor - Currently selected color value
 * @param {function} props.onColorChange - Callback when color is selected
 * @param {string} props.label - Label for the color selector (optional)
 */
const ColorSelector = ({ 
  colors = [], 
  selectedColor, 
  onColorChange, 
  label = "Color" 
}) => {
  const theme = useTheme();
  const themeColors = tokens(theme.palette.mode);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body1" fontWeight="500" mb={1.5}>
        {label}
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        {colors.map((color) => (
          <Tooltip key={color.name} title={color.name} arrow>
            <Box
              onClick={() => onColorChange(color.value)}
              sx={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                bgcolor: color.value,
                cursor: 'pointer',
                border: selectedColor === color.value ? `2px solid ${themeColors.primary[400]}` : 'none',
                outline: selectedColor === color.value ? `2px solid #fff` : 'none',
                transition: 'transform 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  transform: 'scale(1.1)'
                }
              }}
            >
              {selectedColor === color.value && (
                <CheckCircleIcon sx={{ color: '#fff', fontSize: '20px' }} />
              )}
            </Box>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default ColorSelector;
